<template>
  <tree-view :key="treeKey" id="customtree" :initial-model="tempData">
    <template #text="{ model }">
      <em :title="model.treeNodeSpec.title">
        <div v-if="model.style === 'file'">
          <i class="bi bi-file-earmark-fill"> </i>
          <span class="btn-event" @click="viewFileEvent(model)">
            {{ model[model.treeNodeSpec.labelProperty] }}
          </span>
        </div>
        <div v-else-if="model.style === 'directory'">
          <i class="bi bi-folder-fill"> </i>
          <span>
            {{ model[model.treeNodeSpec.labelProperty] }}
          </span>
        </div>
      </em>
    </template>
  </tree-view>
</template>

<script setup lang="ts">
import "../../../node_modules/@grapoza/vue-tree/dist/style.css";
import { useFolderStructureStore } from "@/stores/folder_struct";
import { TreeView } from "@grapoza/vue-tree";
import { useAsyncState } from "@vueuse/core";
import { ref, watch } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();
const treeKey = ref(0);
const folderStructureStore = useFolderStructureStore();
const tempData = ref([]);

const forceRerender = () => {
  treeKey.value += 1;
};

watch(
  () => folderStructureStore.convertedStructure,
  () => {
    tempData.value = folderStructureStore.convertedStructure;
    forceRerender();
  }
);
var current_uuid = router.currentRoute.value.params.selectedSearchId.toString();
const serverParams = ref({
  filter_by: "package_uuid:" + current_uuid,
  sort_by: "name:asc",
  q: "*",
  query_by: "name", // can include more fields.
  per_page: 50,
});

const { execute } = useAsyncState(() => {
  return folderStructureStore.fetchTypesenseFile(serverParams.value);
}, null);

const viewFileEvent = (model) => {
  let selectedFile = folderStructureStore.uuidArray.filter(
    (a) => a.name == model.path
  );
  // console.log(selectedFile[0].uuid);
  router.push({
    name: "fileeventlist",
    params: { selectedFileId: selectedFile[0].uuid },
  });
};
</script>

<style scoped>
.bi-folder-fill {
  color: #ffc700;
  font-size: 18px;
  padding-right: 5px;
}
.bi-file-earmark-fill {
  font-size: 16px;
  padding-right: 5px;
}
.btn-event:hover {
  cursor: pointer;
  background: #ffc700;
}
</style>
